import React from "react";
import { Box, Card, CardContent, Typography } from "@mui/material";
import Skeleton from "react-loading-skeleton";

const DashboardChartCard = ({ title, subtitle, isLoading, isEmpty, emptyText = "No data available", children }) => (
  <Card
    sx={{
      height: "100%",
      background: "linear-gradient(135deg, #2a2a2a 0%, #1a1a1a 100%)",
      border: "1px solid rgba(255, 255, 255, 0.1)",
      borderRadius: "12px",
      boxShadow: "0 4px 20px rgba(0, 0, 0, 0.3)",
    }}
  >
    <CardContent sx={{ p: { xs: 2, md: 2.5 } }}>
      <Box sx={{ mb: 2 }}>
        <Typography sx={{ color: "#fff", fontSize: { xs: "17px", md: "20px" }, fontWeight: 700 }}>
          {title}
        </Typography>
        {subtitle && (
          <Typography sx={{ color: "#aaa", fontSize: "13px", mt: 0.5, lineHeight: 1.5 }}>
            {subtitle}
          </Typography>
        )}
      </Box>
      {isLoading ? (
        <Skeleton height={320} style={{ borderRadius: 12 }} />
      ) : isEmpty ? (
        <Box
          sx={{
            height: 260,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            border: "1px dashed rgba(255, 255, 255, 0.14)",
            borderRadius: "12px",
          }}
        >
          <Typography sx={{ color: "#aaa", fontSize: "14px" }}>{emptyText}</Typography>
        </Box>
      ) : (
        <Box sx={{ height: { xs: 260, md: 330 }, width: "100%" }}>{children}</Box>
      )}
    </CardContent>
  </Card>
);

export default DashboardChartCard;
